<template>
  <timeline :entries="entries"/>
</template>

<script>
  import Timeline from "@/components/Timeline.vue";

  export default {
    name: 'TrainingComponent',
    components: {Timeline},
    data: function () {
      return {
        entries: [
          {
            title: 'IMERIR, Perpignan',
            role: 'Manager de systèmes informatiques et robotiques',
            period: '2016 à 2019',
            text: 'L\'IMERIR forme des spécialistes de l\'informatique appliquée aux nouvelles technologies : cybersécurité, intelligence artificielle, internet des objets, robotique humanoïde et industrielle, cobotique, fabrication additive, machines et objets connectés.',
            groups: [
              {label: 'Professionnalisation', items: ['2016 : stage à IKCOM', '2017 : stage au laboratoire de Banyuls-sur-Mer', '2017 à 2019 : alternance à Renault']},
              {label: 'Enseignement', items: ['Management', 'Informatique', 'Robotique', 'Spécialité « Smart Object and Cloud » (IoT)']}
            ],
            logo: '/img/imerir.png'
          },
          {
            title: 'UPVD, Perpignan',
            role: 'Licence 3 en calcul numérique',
            period: '2016 à 2017',
            text: 'Licence 3 suivie en parallèle de la première année à l\'IMERIR : développement Android, mathématiques, paradigmes de programmation.',
            logo: '/img/upvd.png'
          },
          {
            title: 'IUT de La Rochelle',
            role: 'DUT informatique, spécialité informatique embarquée',
            period: '2014 à 2016',
            text: 'DUT suivi en deux ans avant de rejoindre un cycle ingénieur.',
            items: [
              'Réalisation de multiples projets étudiants',
              'Projet réalisé en réponse à un besoin professionnel pour l\'entreprise Tecdron',
              'Spécialité informatique embarquée'
            ],
            logo: '/img/iut_la_rochelle.png'
          },
          {
            title: 'Lycée Jean de Lattre de Tassigny, La Roche-sur-Yon',
            role: 'Baccalauréat STI2D, spécialité SIN',
            period: '2012 à 2014',
            text: 'Spécialité Systèmes d\'information et numérique (SIN), mention bien. Projet de fin d\'année : un terrarium automatisé avec un Arduino.',
            logo: '/img/dlt.png'
          },
          {
            title: 'Lycée François Truffaut, Challans',
            role: 'Seconde générale, option CIT',
            period: '2011 à 2012',
            text: 'Une année de seconde au cours de laquelle je découvre un peu plus l\'informatique.'
          },
          {
            title: 'Collège Saint-Joseph',
            period: '2007 à 2011',
            text: 'Premiers pas en informatique avec Visual Studio. Stage chez un électricien (Evident) et stage dans une société informatique (DIS Informatique).',
            logo: '/img/logo_saint_joseph.jpg'
          }
        ]
      }
    }
  }
</script>
